import { CargoUnit, CargoUnitValue } from '@/types';

export const formatWeight = ({ value, unit }: CargoUnitValue): string => {
  const formatter = new Intl.NumberFormat('en-EN');

  if (value) {
    if (unit?.toUpperCase() === 'KGS' || unit?.toUpperCase() === 'KG') {
      const kilos = Number(value);
      return `${formatter.format(kilos)} kg`;
    }
  }

  return '--';
};

export const formatWeightUnit = (unit: string): CargoUnit => {
  const uppercaseUnit = unit.toUpperCase();

  switch (uppercaseUnit) {
    case 'KILOGRAM':
    case 'KGS':
    case 'KG':
    case 'K.G.':
      return 'KG';
    case 'pounds':
    case 'LB':
    case 'LBS':
      return 'LB';
    default:
      return uppercaseUnit as CargoUnit;
  }
};
